// extracted by mini-css-extract-plugin
export default {"titleShoutOut":"dfs437bFT23nwtGQ9hbnzA==","titleMission":"pMGVShRopyr902C4P5BdiA=="};